import { Component } from '@angular/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';
import { FormBuilder } from '@angular/forms';
import { Globals } from "../../../../globals";
import { ConfigurationServices } from "../../services";
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the ConfigurationPaymentComerciaGlobalPayTopPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-configuration-payment-comerciaglobalpay-top',
  templateUrl: 'configuration-payment-comerciaglobalpay-top.html',
})
export class ConfigurationPaymentComerciaGlobalPayTopPage {

  public comerciaglobalpay_top_merchant_id: string = ''
  public comerciaglobalpay_top_terminal_id: string = '';
  public comerciaglobalpay_top_activation_code: string = '';

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public fb: FormBuilder,
    public configurationServices: ConfigurationServices,
    public globals: Globals,
    public translate: TranslateService,
    public toastCtrl: ToastController) {


  }

  ionViewWillEnter() {
    if (this.globals.restaurant.payment_method_comerciaglobalpay_top_merchant_id != undefined) {
      this.comerciaglobalpay_top_merchant_id = this.globals.restaurant.payment_method_comerciaglobalpay_top_merchant_id;
    }
    if (this.globals.restaurant.payment_method_comerciaglobalpay_top_terminal_id != undefined) {
      this.comerciaglobalpay_top_terminal_id = this.globals.restaurant.payment_method_comerciaglobalpay_top_terminal_id;
    }
    if (this.globals.restaurant.payment_method_comerciaglobalpay_top_activation_code != undefined) {
      this.comerciaglobalpay_top_activation_code = this.globals.restaurant.payment_method_comerciaglobalpay_top_activation_code;
    }
  }

  changeComerciaGlobalPayTop(active) {
    if (this.comerciaglobalpay_top_merchant_id != '' && this.comerciaglobalpay_top_terminal_id != '' && this.comerciaglobalpay_top_activation_code) {
      this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
        'payment_method_comerciaglobalpay_top': active,
        'payment_method_comerciaglobalpay_top_merchant_id': this.comerciaglobalpay_top_merchant_id,
        'payment_method_comerciaglobalpay_top_terminal_id': this.comerciaglobalpay_top_terminal_id,
        'payment_method_comerciaglobalpay_top_activation_code': this.comerciaglobalpay_top_activation_code,
      }).then(() => {
        this.globals.restaurant.payment_method_comerciaglobalpay_top = active;
        this.globals.restaurant.payment_method_comerciaglobalpay_top_merchant_id = this.comerciaglobalpay_top_merchant_id;
        this.globals.restaurant.payment_method_comerciaglobalpay_top_terminal_id = this.comerciaglobalpay_top_terminal_id;
        this.globals.restaurant.payment_method_comerciaglobalpay_top_activation_code = this.comerciaglobalpay_top_activation_code;
      });
      //toast
      let toast = this.toastCtrl.create({
        message: active ? this.translate.instant('config-activado') : this.translate.instant('config-desactivado'),
        duration: 2000,
        position: 'top'
      });
      toast.present();
    } else {
      this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
        'payment_method_comerciaglobalpay_top': false
      }).then(() => {
        this.globals.restaurant.payment_method_redsys_top = false;
      });
      //toast
      let toast = this.toastCtrl.create({
        message: this.translate.instant('general-faltan-datos'),
        duration: 2000,
        position: 'top'
      });
      toast.present();
    }
  }

  saveConfig() {
    if (this.comerciaglobalpay_top_merchant_id != '' && this.comerciaglobalpay_top_terminal_id != '' && this.comerciaglobalpay_top_activation_code) {
      this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
        'payment_method_comerciaglobalpay_top_merchant_id': this.comerciaglobalpay_top_merchant_id,
        'payment_method_comerciaglobalpay_top_terminal_id': this.comerciaglobalpay_top_terminal_id,
        'payment_method_comerciaglobalpay_top_activation_code': this.comerciaglobalpay_top_activation_code,
      }).then(() => {
        this.globals.restaurant.payment_method_comerciaglobalpay_top_merchant_id = this.comerciaglobalpay_top_merchant_id;
        this.globals.restaurant.payment_method_comerciaglobalpay_top_terminal_id = this.comerciaglobalpay_top_terminal_id;
        this.globals.restaurant.payment_method_comerciaglobalpay_top_activation_code = this.comerciaglobalpay_top_activation_code;

        let toast = this.toastCtrl.create({
          message: this.translate.instant('general-guardado-correctamente'),
          duration: 2000,
          position: 'top'
        });
        toast.present();
        this.changeComerciaGlobalPayTop(true);

      });
    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('general-faltan-datos'),
        duration: 2000,
        position: 'top'
      });
      toast.present();
      this.changeComerciaGlobalPayTop(false);
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-payment-methods/configuration-payment-comerciaglobalpay-top/configuration-payment-comerciaglobalpay-top.ts